import React from "react";
import styled from "styled-components";
import CheckBox from "../../assets/svg/check-svgrepo-com"
export default function BlogBox({ tag, title, text, action, author }) {
  return (
    <WrapperBtn className="animate" >

      <Wrapper className="whiteBg radius8 shadow">
      <TitleWrapper className="row textCenter">
            <div className="col-xs-9">
              <h3 className="font20 extraBold">{title}</h3>
            </div>          
            <div className="col-xs-3">
              <CheckBox height="40px"/>
            </div>
        </TitleWrapper>
        <p className="font13" style={{ padding: "30px 0" }}>
          {text}
        </p>
        <p className="font13 extraBold">{author}</p>
        
      </Wrapper>
    </WrapperBtn>
  );
}

const Wrapper = styled.div`
  width: 100%;
  text-align: left;
  padding: 20px 30px;
  margin-top: 30px;
`;

const TitleWrapper = styled.div`
  align-Items: center;  
`;
const WrapperBtn = styled.button`
  border: 0px;
  outline: none;
  background-color: transparent;

`;
